<template>
  <SogCard class="sog-card-without-title">
    <SogCardContent>
      <table>
        <tr>
          <td>Name</td>
          <td>
            <SogDataLabel
              :value="file?.name"
            />
          </td>
        </tr>
        <tr>
          <td>Beschreibung</td>
          <td>
            <SogDataLabel
              :value="file?.description"
            />
          </td>
        </tr>
        <tr>
          <td>Dateiname</td>
          <td>
            <SogDataLabel
              :value="file?.fileName"
            />
          </td>
        </tr>
        <tr>
          <td>Datum</td>
          <td>
            <SogDataLabel
              :value="file?.date"
              :value-type="SogDataLabelValueType.DateTime"
            />
          </td>
        </tr>
      </table>
    </SogCardContent>
    <SogCardActions>
      <slot />
    </SogCardActions>
  </SogCard>
</template>

<script setup lang="ts">

import SogCard from "@/shared/ui/SogCard.vue";
import SogCardContent from "@/shared/ui/SogCardContent.vue";
import SogDataLabel from "@/shared/ui/SogDataLabel.vue";
import SogCardActions from "@/shared/ui/SogCardActions.vue";
import ListFile from "@/shared/model/ListFile";
import {SogDataLabelValueType} from "@/shared/ui/types/SogDataLabelValueType";


interface Props {
  file?:ListFile
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const props = withDefaults(defineProps<Props>(), {
      file:undefined
    }
)
</script>

<style scoped>

</style>
